import React from 'react';
import PropTypes from 'prop-types';

import FavouriteIcon from '../icons/FavouriteIcon';
import FavoriteIconWithBorder from '../icons/FavoriteIconWithBorder';

class Favourite extends React.Component {
  state = {
    hovered: false
  };

  handleAddHover = () => {
    this.setState({ hovered: true });
  };

  handleRemoveHover = () => {
    this.setState({ hovered: false });
  };

  handleClick = e => {
    e && e.stopPropagation();
    e && e.preventDefault();
    this.props.onClick();
  };

  render() {
    const { selected, className, iconWithBorder } = this.props;
    const { hovered } = this.state;

    return (
      <span
        className={className}
        onClick={this.handleClick}
        onMouseEnter={this.handleAddHover}
        onMouseLeave={this.handleRemoveHover}
        onTouchStart={this.handleAddHover}
        onTouchEnd={this.handleRemoveHover}
        data-test="favorite-icon"
      >
        {iconWithBorder ? (
          <FavoriteIconWithBorder active={hovered || selected} />
        ) : (
          <FavouriteIcon theme={selected || hovered ? 'favourite' : 'light'} />
        )}
      </span>
    );
  }
}

Favourite.defaultProps = {
  onClick: () => {},
  className: '',
  iconWithBorder: false
};

Favourite.propTypes = {
  selected: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  iconWithBorder: PropTypes.bool
};

export default Favourite;
